module.exports = __webpack_public_path__ + "static/fp-about-cyd-0e76bc2d30f658ba18af5159d9b5cc69.jpg";